import { CloseIcon } from '@chakra-ui/icons'
import { Center, Flex, IconButton, Text } from '@chakra-ui/react'
import { templateTypeNames } from '@hb/shared'
import { TemplateMenu } from './TemplateMenu/TemplateMenu'
import { useTemplateView } from './contexts/view'

export const SelectTemplateView = ({
  height,
  width,
  onClose,
}: {
  height: number
  width: number
  onClose?: () => void
}) => {
  const { templateId, type, setManualTemplateId } = useTemplateView()
  return (
    <Flex flexFlow="column" w={`${width}px`} h={`${height}px`} bg="gray.100">
      <Center
        bg="gray.50"
        px={4}
        py={3}
        w="100%"
        gap={2}
        flexFlow="column"
        borderBottom="1px solid #ababab">
        <Flex w="100%" align="center">
          <Text fontSize="lg" fontWeight={500} fontFamily="Open Sans">
            Select a template
          </Text>
          {onClose ? (
            <IconButton
              ml="auto"
              borderRadius="full"
              size="sm"
              aria-label="Close"
              icon={<CloseIcon />}
              onClick={onClose}
            />
          ) : null}
        </Flex>
        <TemplateMenu
          templateType={type}
          templateId={templateId}
          onChange={({ template, practiceId }) => {
            setManualTemplateId({
              practiceId,
              templateId: template.id,
            })
          }}
          insuranceProviderId={null}
          focusOnMount
          large
        />
      </Center>
      <Center w="100%" h="100%">
        <Text fontSize="lg"> Template required for {templateTypeNames[type]} documents </Text>
      </Center>
    </Flex>
  )
}
